import { VehicleInspectionContextKey } from './VehicleInspection.utils';

export interface VehicleInspectionContent {
  searchBox: {
    title: string;
    label: string;
    placeholder: string;
    buttonText: string;
  };
  appBanner: {
    title: string;
    subtitle?: string;
    iconText?: string;
    iconTextTwo?: string;
    ctaText?: string;
  };
}

const farFromDueAppBanner: VehicleInspectionContent['appBanner'] = {
  title: 'Full kontroll på bilen i appen',
  subtitle: 'Varsler, bilinfo og oversikt samlet på ett sted',
  iconText: 'Få påminnelse for EU-kontrollen din i appen',
};

const dueSoonAppBanner: VehicleInspectionContent['appBanner'] = {
  title: 'Bestill time raskt i appen',
  iconTextTwo: 'Se status og varsler for din bil',
};

export const getAppBannerContent = (
  contextKey?: VehicleInspectionContextKey,
  hasApp?: boolean,
): VehicleInspectionContent['appBanner'] => {
  let baseContent: VehicleInspectionContent['appBanner'];
  switch (contextKey) {
    case VehicleInspectionContextKey.DueSoon:
      baseContent = dueSoonAppBanner;
      break;
    case VehicleInspectionContextKey.Overdue:
    case VehicleInspectionContextKey.FarFromDue:
    default:
      baseContent = farFromDueAppBanner;
      break;
  }

  return {
    ...baseContent,
    ctaText: hasApp ? 'Følg bilen din i appen' : 'Last ned appen',
  };
};

export const shouldShowAppBanner = (hasContextContent: boolean, hasModuleContent: boolean): boolean =>
  !hasContextContent && !hasModuleContent;
